import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmpksf5me_7/layouts/custom.vue").then(m => m.default || m))
}